<template>
    <div>
        <Row :gutter="32">
            <Col span="8">

                <Form ref="ftpInfo" :model="ftpInfo" :rules="ruleValidate" :label-width="120">
                  <FormItem label="协议" prop="proto">
                    <Select v-model="ftpInfo.proto" placeholder="请选择协议">
                      <Option value="ftp">FTP</Option>
                      <!--<Option value="sftp">SFTP</Option>-->
                      <Option value="http">HTTP</Option>
                    </Select>
                  </FormItem>
                    <FormItem label="服务器名称" prop="ftpName" inline>
                        <Input v-model="ftpInfo.ftpName" placeholder="请输入服务器名称" />
                    </FormItem>
                    <FormItem label="服务器地址" prop="hostIP" inline>
                        <Input v-model="ftpInfo.hostIP" placeholder="请输入服务器地址" />
                    </FormItem>
                  <FormItem label="存放目录" prop="uri">
                    <Input v-model="ftpInfo.uri" placeholder="请输入存放目录"  />
                  </FormItem>
                    <div v-if="isshowquer">
                    <FormItem label="端口" prop="port">
                        <Input v-model="ftpInfo.port" placeholder="请输入端口" />
                    </FormItem>

                    <FormItem label="用户名" prop="username">
                        <Input v-model="ftpInfo.username" placeholder="请输入用户名" />
                    </FormItem>
                    <FormItem label="密码" prop="password">
                        <Input type="password" v-model="ftpInfo.password" placeholder="请输入密码" />
                    </FormItem>
                    </div>
                    <FormItem>
                        <Button type="primary" @click="handleSubmit('ftpInfo')" :loading="loading">
                          <span v-if="!loading">上传</span>
                          <span v-else>上传中</span>
                        </Button>
                        <Button @click="handleReset('ftpInfo')" style="margin-left: 8px">重置</Button>
                    </FormItem>
                </Form>
          </Col>
            <Col span="16">
                <Table border :columns="ftpTable" :data="ftpList"></Table>
          </Col>
        </Row>
        <Drawer
            title="编辑"
            v-model="editFormVisible"
            width="320"
            :mask-closable="false"

        >
            <Form :model="editForm">
              <FormItem label="协议" prop="proto">
                <Select v-model="editForm.proto" placeholder="请选择协议">
                  <Option value="ftp">FTP</Option>
                  <!--<Option value="sftp">SFTP</Option>-->
                  <Option value="http">HTTP</Option>
                </Select>
              </FormItem>
                <FormItem label="服务器名称" prop="ftpName" inline>
                    <Input v-model="editForm.ftpName" placeholder="请输入服务器名称" />
                </FormItem>
                <FormItem label="服务器地址" prop="hostIP" inline>
                    <Input v-model="editForm.hostIP" placeholder="请输入服务器IP地址" disabled />
                </FormItem>
              <div v-if="isshowend">
                <FormItem label="端口" prop="port">
                    <Input v-model="editForm.port" placeholder="请输入端口" />
                </FormItem>

                <FormItem label="存放目录" prop="uri">
                    <Input v-model="editForm.uri" disabled />
                </FormItem>
                <FormItem label="用户名" prop="username">
                    <Input v-model="editForm.username" placeholder="请输入用户名" />
                </FormItem>
                <FormItem label="密码" prop="password">
                    <Input type="password" v-model="editForm.password" placeholder="请输入密码" />
                </FormItem>
              </div>
            </Form>
            <div class="version-drawer-footer">
                <Button style="margin-right: 8px" @click="editFormVisible = false">取消</Button>
                <Button type="primary" @click="editSubmit">确认</Button>
            </div>
        </Drawer>
      <template>
        <!--<Button type="primary" @click="modal1 = true">提示信息</Button>-->
        <Modal
          v-model="modal1"
          title="提示信息"
          @on-ok="ok"
          @on-cancel="cancel">
          <p>确定要删除该条升级包信息吗？</p>
        </Modal>
      </template>
    </div>
</template>
<script>
import {uploadFtpInfo, getFtpList, editFtpInfo, removeFtpInfo} from '@/api/data'
export default {
  data () {
    return {
      loading: false,
      isshowquer:true,
      isshowend:true,
      ftpList: [],
      editFormVisible: false,
      delid:'',
      modal1: false,
      ftpInfo: {
        ftpName: '',
        hostIP: '',
        port: '',
        proto: '',
        uri: '',
        username: '',
        password: ''
      },
      editForm: {
        ftpName: '',
        hostIP: '',
        port: '',
        proto: '',
        uri: '',
        username: '',
        password: ''
      },
      ruleValidate: {
        ftpName: [
          { required: true, message: '请输入服务器名称', trigger: 'blur' }
        ],
        hostIP: [
          { required: true, message: '请输入服务器地址', trigger: 'blur' }
        ],
        port: [
          { required: true, message: '请输入端口', trigger: 'blur' }
        ],
        proto: [
          { required: true, message: '请选择协议', trigger: 'change' }
        ],
        uri: [
          { required: true, message: '请输入存放目录', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      ftpTable: [
        {
          type: 'index',
          indexMethod: (row) => {
            return row.id
          },
          width: 50,
          align: 'center'
        },
        {
          title: '服务器名称',
          key: 'ftpName',
          algin: 'center',
        },
        {
          title: '服务器地址',
          algin: 'center',
          key: 'hostIP'
        },
        {
          title: '端口',
          algin: 'center',
          key: 'port'
        },
        {
          title: '协议',
          algin: 'center',
          key: 'proto'
        },
        {
          title: '存放目录',
          algin: 'center',
          key: 'uri'
        },
        {
          title: '操作',
          key: 'action',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let self = this
            return h('div', [
//              h(
//                'Button',
//                {
//                  props: {
//                    type: 'primary',
//                    size: 'small'
//                  },
//                  style: {
//                    marginRight: '5px'
//                  },
//                  on: {
//                    click: () => {
//                      self.handleEdit(params.row)
//                    }
//                  }
//                },
//                '编辑'
//              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {

                      this.modal1=true;
                      this.delid=params.row.id
//                      self.handleDel(params.row.id)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ]
    }
  },
//表单页面监听
  watch: {

    "ftpInfo.proto": {
      handler :function(val){
          if(val=='http'){
//              alert("666")
             this.isshowquer=false;
          }
          else{
            this.isshowquer=true;
          }
      }
    },

//    "editForm.proto": {
//      handler :function(val){
//        if(val=='http'){
////          alert("666")
//          this.isshowend=false;
//        }
//        else{
//          this.isshowend=true;
//        }
//      }
//    },
  },

  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          uploadFtpInfo(this.ftpInfo).then((res) => {
            let status = res.data.meta.success
            let msg = res.data.meta.message
            if (status) {
              this.handleListFtp()
              this.$Message.success('上传成功')
            } else {
              this.$Message.error(msg)
            }
            this.loading = false
          })
        }
      })
    },

    ok () {
     this.handleDel (this.delid);
    },
    cancel () {
      this.$Message.info('取消删除');
    },
    handleDel (index) {
      let param = {id: index}
      removeFtpInfo(param).then((res) => {
        let status = res.data.meta.success
        if (status) {
          this.handleListFtp()
          this.$Message.success('删除成功')
        } else {
          this.$Message.error('删除失败')
        }
        this.handleListFtp()
      })
    },
//    handleEdit (row) {
//      this.editFormVisible = true
//      this.editForm = Object.assign({}, row)
//      this.editForm.username = ''
//      this.editForm.password = ''
//    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    handleListFtp () {
      getFtpList().then((res) => {
        this.ftpList = res.data.data
      })
    },
    editSubmit () {
      editFtpInfo(this.editForm).then((res) => {
        let status = res.data.meta.success
        if (status) {
          this.handleListFtp()
          this.$Message.success('修改成功')
        } else {
          this.$Message.error('修改失败')
        }
        this.editFormVisible = false
      })
    }
  },
  created () {
    this.handleListFtp()
  }
}
</script>
